// Public legal pages — Mentions légales & Politique de confidentialité (RGPD)
import { useI18n } from "@/i18n/I18nContext";
import Ornament from "@/components/Ornament";

const LEGAL = {
  fr: {
    title: "Mentions légales",
    kicker: "Informations légales",
    sections: [
      {
        h: "Éditeur du site",
        body: "Le site www.prieure-saint-leonard.fr est édité par l'association « Les Amis du Prieuré saint Léonard », association loi 1901 reconnue d'intérêt général, dont le siège social est : Prieuré saint Léonard, 50300 Vains, France.",
      },
      {
        h: "Directeur de la publication",
        body: "Le directeur de la publication est le président de l'association.",
      },
      {
        h: "Contact",
        body: "Pour toute question relative au site : contact@prieure-saint-leonard.fr · +33 7 45 20 09 00",
      },
      {
        h: "Hébergement",
        body: "Le site est hébergé sur une infrastructure cloud sécurisée, conforme aux exigences du Règlement Général sur la Protection des Données (RGPD).",
      },
      {
        h: "Propriété intellectuelle",
        body: "L'ensemble des contenus présents sur ce site (textes, photographies, vidéos, logo, charte graphique) sont la propriété exclusive de l'association ou de leurs auteurs respectifs. Toute reproduction, totale ou partielle, est interdite sans autorisation écrite préalable.",
      },
      {
        h: "Crédits photographiques",
        body: "© Les Amis du Prieuré saint Léonard et leurs ayants droit. Certaines images proviennent du fonds documentaire de l'association.",
      },
    ],
  },
  en: {
    title: "Legal notice",
    kicker: "Legal information",
    sections: [
      {
        h: "Publisher",
        body: "The website www.prieure-saint-leonard.fr is published by the association \"Les Amis du Prieuré saint Léonard\", a non-profit association under French law (1901), recognised as serving the public interest. Registered office: Prieuré saint Léonard, 50300 Vains, France.",
      },
      { h: "Publication director", body: "The publication director is the president of the association." },
      { h: "Contact", body: "For any question about the website: contact@prieure-saint-leonard.fr · +33 7 45 20 09 00" },
      { h: "Hosting", body: "The website is hosted on a secure cloud infrastructure compliant with the General Data Protection Regulation (GDPR)." },
      { h: "Intellectual property", body: "All content on this site (texts, photographs, videos, logo, design) is the exclusive property of the association or its respective authors. Any reproduction, total or partial, is prohibited without prior written permission." },
      { h: "Photo credits", body: "© Les Amis du Prieuré saint Léonard and rights holders. Some images come from the association's archives." },
    ],
  },
  it: {
    title: "Note legali",
    kicker: "Informazioni legali",
    sections: [
      { h: "Editore del sito", body: "Il sito www.prieure-saint-leonard.fr è pubblicato dall'associazione « Les Amis du Prieuré saint Léonard », associazione di interesse pubblico (Legge 1901). Sede legale: Prieuré saint Léonard, 50300 Vains, Francia." },
      { h: "Direttore della pubblicazione", body: "Il direttore della pubblicazione è il presidente dell'associazione." },
      { h: "Contatti", body: "Per qualsiasi domanda sul sito: contact@prieure-saint-leonard.fr · +33 7 45 20 09 00" },
      { h: "Hosting", body: "Il sito è ospitato su un'infrastruttura cloud sicura conforme al Regolamento Generale sulla Protezione dei Dati (GDPR)." },
      { h: "Proprietà intellettuale", body: "Tutti i contenuti presenti sul sito (testi, fotografie, video, logo, identità grafica) sono di proprietà esclusiva dell'associazione o dei rispettivi autori. Ogni riproduzione, totale o parziale, è vietata senza autorizzazione scritta preventiva." },
      { h: "Crediti fotografici", body: "© Les Amis du Prieuré saint Léonard e aventi diritto." },
    ],
  },
  es: {
    title: "Aviso legal",
    kicker: "Información legal",
    sections: [
      { h: "Editor del sitio", body: "El sitio www.prieure-saint-leonard.fr es editado por la asociación « Les Amis du Prieuré saint Léonard », asociación de interés general (Ley 1901). Sede social: Prieuré saint Léonard, 50300 Vains, Francia." },
      { h: "Director de publicación", body: "El director de publicación es el presidente de la asociación." },
      { h: "Contacto", body: "Para cualquier pregunta sobre el sitio: contact@prieure-saint-leonard.fr · +33 7 45 20 09 00" },
      { h: "Alojamiento", body: "El sitio está alojado en una infraestructura en la nube segura, conforme al Reglamento General de Protección de Datos (RGPD)." },
      { h: "Propiedad intelectual", body: "Todos los contenidos presentes en este sitio (textos, fotografías, vídeos, logotipo, diseño) son propiedad exclusiva de la asociación o de sus respectivos autores. Toda reproducción, total o parcial, está prohibida sin autorización escrita previa." },
      { h: "Créditos fotográficos", body: "© Les Amis du Prieuré saint Léonard y derechohabientes." },
    ],
  },
  de: {
    title: "Impressum",
    kicker: "Rechtliche Hinweise",
    sections: [
      { h: "Herausgeber", body: "Die Website www.prieure-saint-leonard.fr wird vom Verein „Les Amis du Prieuré saint Léonard\" herausgegeben, einem gemeinnützigen Verein (Gesetz 1901). Sitz: Prieuré saint Léonard, 50300 Vains, Frankreich." },
      { h: "Verantwortlich für den Inhalt", body: "Der verantwortliche Direktor ist der Präsident des Vereins." },
      { h: "Kontakt", body: "Für jede Frage zur Website: contact@prieure-saint-leonard.fr · +33 7 45 20 09 00" },
      { h: "Hosting", body: "Die Website wird auf einer sicheren Cloud-Infrastruktur gehostet, die der Datenschutz-Grundverordnung (DSGVO) entspricht." },
      { h: "Urheberrecht", body: "Alle Inhalte dieser Website (Texte, Fotos, Videos, Logo, Design) sind ausschließliches Eigentum des Vereins oder ihrer jeweiligen Urheber. Jede vollständige oder teilweise Vervielfältigung ist ohne vorherige schriftliche Genehmigung untersagt." },
      { h: "Bildnachweise", body: "© Les Amis du Prieuré saint Léonard und Rechteinhaber." },
    ],
  },
  pt: {
    title: "Aviso legal",
    kicker: "Informações legais",
    sections: [
      { h: "Editor do site", body: "O site www.prieure-saint-leonard.fr é editado pela associação « Les Amis du Prieuré saint Léonard », associação de interesse geral (Lei 1901). Sede social: Prieuré saint Léonard, 50300 Vains, França." },
      { h: "Diretor da publicação", body: "O diretor da publicação é o presidente da associação." },
      { h: "Contacto", body: "Para qualquer questão sobre o site: contact@prieure-saint-leonard.fr · +33 7 45 20 09 00" },
      { h: "Alojamento", body: "O site está alojado numa infraestrutura cloud segura, em conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD)." },
      { h: "Propriedade intelectual", body: "Todos os conteúdos presentes neste site (textos, fotografias, vídeos, logótipo, identidade gráfica) são propriedade exclusiva da associação ou dos respetivos autores. Qualquer reprodução, total ou parcial, é proibida sem autorização escrita prévia." },
      { h: "Créditos fotográficos", body: "© Les Amis du Prieuré saint Léonard e detentores dos direitos." },
    ],
  },
};

const PRIVACY = {
  fr: {
    title: "Politique de confidentialité",
    kicker: "Protection de vos données — RGPD",
    sections: [
      {
        h: "Responsable du traitement",
        body: "Les Amis du Prieuré saint Léonard, Prieuré saint Léonard, 50300 Vains, France. Contact : contact@prieure-saint-leonard.fr",
      },
      {
        h: "Données collectées",
        body: "Nous collectons uniquement les données nécessaires aux finalités suivantes : adhésion à l'association, inscription aux événements, dons, demande de contact, inscription à la newsletter, espace membre. Champs typiques : nom, prénom, email, téléphone, adresse postale (pour adhésion / reçu fiscal), choix d'événements, préférences d'hébergement.",
      },
      {
        h: "Finalités",
        body: "Les données sont utilisées exclusivement pour : (1) gérer votre adhésion, vos inscriptions et vos paiements ; (2) vous transmettre les confirmations et les reçus fiscaux ; (3) vous envoyer notre lettre d'information (avec votre consentement explicite, désinscription en un clic) ; (4) animer l'espace membre (forum, covoiturage, galerie).",
      },
      {
        h: "Bases légales",
        body: "Exécution d'un contrat (adhésion, billetterie), obligation légale (reçus fiscaux art. 200 et 238 bis CGI), consentement explicite (newsletter), intérêt légitime (gestion associative).",
      },
      {
        h: "Durée de conservation",
        body: "Données d'adhésion et de dons : 10 ans (obligation comptable et fiscale). Données newsletter : jusqu'à désinscription. Données espace membre : pendant la durée de votre compte + 1 an. Messages de contact : 3 ans.",
      },
      {
        h: "Destinataires",
        body: "Vos données ne sont jamais vendues. Elles sont transmises uniquement aux sous-traitants techniques nécessaires : SumUp (paiement), Brevo (envoi d'emails), hébergeur cloud. Tous sont conformes RGPD.",
      },
      {
        h: "Cookies",
        body: "Le site utilise uniquement des cookies strictement nécessaires (session, préférence de langue). Aucun cookie publicitaire ni de mesure d'audience tierce.",
      },
      {
        h: "Vos droits",
        body: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité, de limitation et d'opposition. Pour exercer ces droits : contact@prieure-saint-leonard.fr. Vous pouvez également déposer une réclamation auprès de la CNIL (www.cnil.fr).",
      },
    ],
  },
  en: {
    title: "Privacy policy",
    kicker: "Your data protection — GDPR",
    sections: [
      { h: "Data controller", body: "Les Amis du Prieuré saint Léonard, Prieuré saint Léonard, 50300 Vains, France. Contact: contact@prieure-saint-leonard.fr" },
      { h: "Data collected", body: "We collect only the data needed for: membership, event registration, donations, contact requests, newsletter subscription, member area. Typical fields: name, email, phone, postal address (for membership / tax receipts), event choices, accommodation preferences." },
      { h: "Purposes", body: "Data are used exclusively to: (1) manage your membership, registrations and payments; (2) send confirmations and tax receipts; (3) send our newsletter (with your explicit consent, one-click unsubscribe); (4) operate the member area." },
      { h: "Legal basis", body: "Contract execution (membership, ticketing), legal obligation (tax receipts French CGI art. 200 & 238 bis), explicit consent (newsletter), legitimate interest (association management)." },
      { h: "Retention", body: "Membership and donation data: 10 years (accounting and tax obligations). Newsletter: until unsubscription. Member area: lifetime of your account + 1 year. Contact messages: 3 years." },
      { h: "Recipients", body: "Your data are never sold. They are shared only with strictly necessary technical processors: SumUp (payment), Brevo (emails), cloud host — all GDPR-compliant." },
      { h: "Cookies", body: "The site uses only strictly necessary cookies (session, language preference). No advertising cookies, no third-party analytics." },
      { h: "Your rights", body: "Under GDPR, you have the right to access, rectify, erase, port, restrict and oppose. To exercise these rights: contact@prieure-saint-leonard.fr. You may also file a complaint with the CNIL (www.cnil.fr)." },
    ],
  },
  it: {
    title: "Informativa sulla privacy",
    kicker: "Protezione dei dati — GDPR",
    sections: [
      { h: "Titolare del trattamento", body: "Les Amis du Prieuré saint Léonard, Prieuré saint Léonard, 50300 Vains, Francia. Contatti: contact@prieure-saint-leonard.fr" },
      { h: "Dati raccolti", body: "Raccogliamo solo i dati necessari per: adesione, iscrizione agli eventi, donazioni, richieste di contatto, iscrizione alla newsletter, area soci. Campi tipici: nome, email, telefono, indirizzo postale, scelte di evento, preferenze di alloggio." },
      { h: "Finalità", body: "I dati sono utilizzati esclusivamente per gestire l'adesione, le iscrizioni, i pagamenti, inviare conferme e ricevute fiscali, inviare la newsletter (con consenso esplicito) e animare l'area soci." },
      { h: "Basi giuridiche", body: "Esecuzione del contratto, obbligo legale, consenso esplicito, interesse legittimo." },
      { h: "Conservazione", body: "Dati di adesione e donazioni: 10 anni. Newsletter: fino alla cancellazione. Area soci: durata dell'account + 1 anno. Messaggi di contatto: 3 anni." },
      { h: "Destinatari", body: "I dati non vengono mai venduti. Sono condivisi solo con i fornitori tecnici strettamente necessari: SumUp, Brevo, hosting cloud — tutti conformi GDPR." },
      { h: "Cookie", body: "Il sito utilizza solo cookie strettamente necessari. Nessun cookie pubblicitario." },
      { h: "I tuoi diritti", body: "Ai sensi del GDPR, hai diritto di accesso, rettifica, cancellazione, portabilità, limitazione e opposizione. Per esercitare questi diritti: contact@prieure-saint-leonard.fr." },
    ],
  },
  es: {
    title: "Política de privacidad",
    kicker: "Protección de sus datos — RGPD",
    sections: [
      { h: "Responsable del tratamiento", body: "Les Amis du Prieuré saint Léonard, Prieuré saint Léonard, 50300 Vains, Francia. Contacto: contact@prieure-saint-leonard.fr" },
      { h: "Datos recopilados", body: "Recogemos únicamente los datos necesarios para: adhesión, inscripción a eventos, donaciones, solicitudes de contacto, suscripción a la newsletter, área de socios. Campos típicos: nombre, correo electrónico, teléfono, dirección postal, elecciones de evento, preferencias de alojamiento." },
      { h: "Finalidades", body: "Los datos se utilizan exclusivamente para gestionar la adhesión, inscripciones, pagos, enviar confirmaciones y recibos fiscales, enviar la newsletter (con consentimiento explícito) y animar el área de socios." },
      { h: "Bases jurídicas", body: "Ejecución de contrato, obligación legal, consentimiento explícito, interés legítimo." },
      { h: "Conservación", body: "Datos de adhesión y donaciones: 10 años. Newsletter: hasta la baja. Área de socios: duración de la cuenta + 1 año. Mensajes de contacto: 3 años." },
      { h: "Destinatarios", body: "Sus datos nunca se venden. Solo se comparten con los proveedores técnicos estrictamente necesarios: SumUp, Brevo, alojamiento en la nube — todos conformes al RGPD." },
      { h: "Cookies", body: "El sitio solo utiliza cookies estrictamente necesarias. Sin cookies publicitarios." },
      { h: "Sus derechos", body: "De conformidad con el RGPD, tiene derecho de acceso, rectificación, supresión, portabilidad, limitación y oposición. Para ejercer estos derechos: contact@prieure-saint-leonard.fr." },
    ],
  },
  de: {
    title: "Datenschutzerklärung",
    kicker: "Schutz Ihrer Daten — DSGVO",
    sections: [
      { h: "Verantwortlicher", body: "Les Amis du Prieuré saint Léonard, Prieuré saint Léonard, 50300 Vains, Frankreich. Kontakt: contact@prieure-saint-leonard.fr" },
      { h: "Erhobene Daten", body: "Wir erheben nur die für folgende Zwecke notwendigen Daten: Mitgliedschaft, Veranstaltungsanmeldung, Spenden, Kontaktanfragen, Newsletter-Abonnement, Mitgliederbereich. Typische Felder: Name, E-Mail, Telefon, Postanschrift, Veranstaltungswahl, Unterkunftspräferenzen." },
      { h: "Zwecke", body: "Die Daten werden ausschließlich verwendet, um Ihre Mitgliedschaft, Anmeldungen und Zahlungen zu verwalten, Bestätigungen und Spendenbescheinigungen zu versenden, den Newsletter zu versenden (mit ausdrücklicher Einwilligung) und den Mitgliederbereich zu betreiben." },
      { h: "Rechtsgrundlagen", body: "Vertragserfüllung, gesetzliche Verpflichtung, ausdrückliche Einwilligung, berechtigtes Interesse." },
      { h: "Speicherdauer", body: "Mitgliedschafts- und Spendendaten: 10 Jahre. Newsletter: bis zur Abmeldung. Mitgliederbereich: Laufzeit Ihres Kontos + 1 Jahr. Kontaktnachrichten: 3 Jahre." },
      { h: "Empfänger", body: "Ihre Daten werden niemals verkauft. Sie werden nur an streng erforderliche technische Auftragsverarbeiter weitergegeben: SumUp, Brevo, Cloud-Hosting — alle DSGVO-konform." },
      { h: "Cookies", body: "Die Website verwendet ausschließlich technisch notwendige Cookies. Keine Werbe-Cookies." },
      { h: "Ihre Rechte", body: "Gemäß DSGVO haben Sie das Recht auf Auskunft, Berichtigung, Löschung, Datenübertragbarkeit, Einschränkung und Widerspruch. Zur Ausübung dieser Rechte: contact@prieure-saint-leonard.fr." },
    ],
  },
  pt: {
    title: "Política de privacidade",
    kicker: "Proteção dos seus dados — RGPD",
    sections: [
      { h: "Responsável pelo tratamento", body: "Les Amis du Prieuré saint Léonard, Prieuré saint Léonard, 50300 Vains, França. Contacto: contact@prieure-saint-leonard.fr" },
      { h: "Dados recolhidos", body: "Recolhemos apenas os dados necessários para: adesão, inscrição em eventos, donativos, pedidos de contacto, subscrição da newsletter, área de sócios. Campos típicos: nome, e-mail, telefone, morada postal, escolhas de evento, preferências de alojamento." },
      { h: "Finalidades", body: "Os dados são utilizados exclusivamente para gerir a adesão, inscrições, pagamentos, enviar confirmações e recibos fiscais, enviar a newsletter (com consentimento explícito) e dinamizar a área de sócios." },
      { h: "Bases jurídicas", body: "Execução de contrato, obrigação legal, consentimento explícito, interesse legítimo." },
      { h: "Conservação", body: "Dados de adesão e donativos: 10 anos. Newsletter: até cancelamento. Área de sócios: duração da conta + 1 ano. Mensagens de contacto: 3 anos." },
      { h: "Destinatários", body: "Os seus dados nunca são vendidos. São partilhados apenas com prestadores técnicos estritamente necessários: SumUp, Brevo, alojamento na nuvem — todos em conformidade com o RGPD." },
      { h: "Cookies", body: "O site utiliza apenas cookies estritamente necessários. Sem cookies publicitários." },
      { h: "Os seus direitos", body: "Nos termos do RGPD, tem direito de acesso, retificação, apagamento, portabilidade, limitação e oposição. Para exercer estes direitos: contact@prieure-saint-leonard.fr." },
    ],
  },
};

function LegalPage({ dict, testId }) {
  const { locale } = useI18n();
  const content = dict[locale] || dict.fr;
  return (
    <div data-testid={testId}>
      <section className="relative" style={{ height: "32vh", minHeight: 240 }}>
        <img src="/photos/prieure-leaves.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-vignette" />
        <div className="container-prieure relative h-full flex flex-col justify-end pb-10">
          <div className="font-caps text-[0.7rem] text-white/90 mb-3" style={{ letterSpacing: "0.25em" }}>
            {content.kicker}
          </div>
          <h1 className="font-display text-4xl sm:text-5xl text-white">{content.title}</h1>
        </div>
      </section>
      <div className="py-16">
        <div className="container-prieure max-w-3xl">
          <Ornament className="mb-8" />
          <div className="space-y-8 font-body">
            {content.sections.map((s, i) => (
              <section key={i}>
                <h2 className="font-display text-xl mb-2" style={{ color: "var(--ink)" }}>{s.h}</h2>
                <p className="leading-relaxed" style={{ color: "var(--ink-2)" }}>{s.body}</p>
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export function MentionsLegales() {
  return <LegalPage dict={LEGAL} testId="mentions-legales-page" />;
}

export function PolitiqueConfidentialite() {
  return <LegalPage dict={PRIVACY} testId="confidentialite-page" />;
}
